import {
  ListingDetailsDtoAuctionStatusEnum,
  ListingDetailsDtoListingTypeEnum,
} from '@unreserved/sdk';

export const AUCTION_STATUS = {
  TO_BE_STARTED: ListingDetailsDtoAuctionStatusEnum.ToBeStarted,
  IN_PROGRESS: ListingDetailsDtoAuctionStatusEnum.InProgress,
  PAUSED: ListingDetailsDtoAuctionStatusEnum.Paused,
  COMPLETED: ListingDetailsDtoAuctionStatusEnum.Completed,
  CANCELLED: ListingDetailsDtoAuctionStatusEnum.Cancelled,
};

export const LISTING_TYPE = {
  PRIVATE_SALE: ListingDetailsDtoListingTypeEnum.PrivateSale,
  LIVE_AUCTION: ListingDetailsDtoListingTypeEnum.Auction,
  REVERSE_AUCTION: ListingDetailsDtoListingTypeEnum.ReverseAuction,
};

export const LIVE_AUCTION_MIN_BID_INCREMENT_BEFORE_RESERVE = 2500;
export const LIVE_AUCTION_MIN_BID_INCREMENT_AFTER_RESERVE = 500;

export function getLiveAuctionMinBidIncrement(reserveMet: boolean): number {
  return reserveMet
    ? LIVE_AUCTION_MIN_BID_INCREMENT_AFTER_RESERVE
    : LIVE_AUCTION_MIN_BID_INCREMENT_BEFORE_RESERVE;
}
